import { useReveal } from "../../../../hooks/useReveal";
import styles from "./TalentsHowItWorks.module.css";

const steps = [
  {
    num: "01",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    title: "Create your profile",
    body: "Set up in under 3 minutes. Showcase what makes you different — beyond the buzzwords.",
  },
  {
    num: "02",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </svg>
    ),
    title: "Take a quick test",
    body: "A short psychometric and skills assessment that uncovers how you actually think and work.",
  },
  {
    num: "03",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <path d="M7.5 4.21l9 5.19M7.5 19.79V14.6L3 12M21 12l-4.5 2.6v5.19M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" />
      </svg>
    ),
    title: "Get AI insights",
    body: "Personalized feedback on your strengths, gaps and growth path — tailored to your goals.",
  },
  {
    num: "04",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 2l2.39 7.36H22l-6.19 4.5L18.2 21 12 16.5 5.8 21l2.39-7.14L2 9.36h7.61z" />
      </svg>
    ),
    title: "Get matched to jobs",
    body: "Real companies discover you based on ability — not connections, schools or job titles.",
  },
];

function StepCard({ num, icon, title, body }) {
  const { ref, isVisible } = useReveal();
  return (
    <div
      ref={ref}
      className={`${styles.step} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={styles.stepNum}>{num}</div>
      <div className={styles.stepIcon}>{icon}</div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}

export default function TalentsHowItWorks() {
  return (
    <section className={styles.section} id="how">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>How it works</span>
          <h2 className={styles.h2}>
            From hidden gem to hired — in four steps
          </h2>
          <p className={styles.sub}>
            No connections. No padded CVs. Just your real ability, surfaced and
            matched to opportunities that fit.
          </p>
        </div>

        <div className={styles.videoWrapper}>
          <iframe
            src="https://www.youtube.com/embed/RBV5sNVyYC8?si=ncylKEsuNS_U2G3R&rel=0&modestbranding=1&showinfo=0&loop=1"
            title="Awasource Talent Walkthrough Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className={styles.grid}>
          {steps.map((s) => (
            <StepCard key={s.num} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
